import { useLoginState } from './useLoginState';

export const useCurrentUser = () => {
	const state = useLoginState();
	return state.user;
};
